/**
 * Rate plan categories recognised by the pricing engine and the operator UI.
 */
export const RATE_PLAN_TYPE = {
    STANDARD: 'STANDARD',
    BAR: 'BAR',
    CORPORATE: 'CORPORATE',
    MEMBER: 'MEMBER',
    PACKAGE: 'PACKAGE',
    PROMOTIONAL: 'PROMOTIONAL',
    OTA: 'OTA',
    WHOLESALE: 'WHOLESALE',
    NEGOTIATED: 'NEGOTIATED',
};
//# sourceMappingURL=rate-plan-types.js.map